import React,{ useContext } from 'react'
import {GlobalLangCtx} from '../../App'
import './BorderComp.css'

const BorderComp = () =>{
    const immagine = './code_it_img/5.png';

    const [selLan, setselLan] = useContext(GlobalLangCtx)

    const fLan = require(`../language_app/json_files/lang[${selLan}].json`)

    return(
        <section>
            <div className='bComp_main_container'>
                <div className="bComp_cont_container">
                    <div className='bBox_title'>
                        {/* BorderComp */}
                        <h1>
                            { fLan.frameName.borderBox.title }
                        </h1>
                    </div>
                    <div className='bComp_boxImg'>
                        <img src={immagine} alt="" />
                    </div>
                    <div className='bBox_subTitle'>
                        <p>
                        { fLan.frameName.borderBox.subTitle }
                        </p>
                    </div>

                </div>
            </div>
        </section>
    )
}


export default BorderComp;